import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Alert from '../UI/Alert';
import Button from '../UI/Button';
import Spinner from '../UI/Spinner';
import ShopSelectionModal from './ShopSelectionModal';

const Login = () => {
  const [credentials, setCredentials] = useState({
    login: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const {
    login,
    showShopSelection,
    handleShopSelected,
    handleShopSelectionCancel
  } = useAuth();

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.login || !credentials.password) {
      setError('Usuario y contraseña son requeridos');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const result = await login(credentials);

      if (result.success) {
        if (!result.requiresShopSelection) {
          navigate('/dashboard');
        }
      } else {
        setError(result.message || 'Credenciales inválidas');
      }
    } catch (err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const onShopSelectedComplete = (updatedUser) => {
    handleShopSelected(updatedUser);
    navigate('/dashboard');
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">InventApp</h1>
          <p className="mt-2 text-sm text-gray-600">Inicia sesión con tus credenciales de Polarik</p>
        </div>

        {error && <Alert type="error" message={error} onClose={() => setError('')} />}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="login" className="block text-sm font-medium text-gray-700">
                Usuario
              </label>
              <input
                id="login"
                name="login"
                type="text"
                required
                value={credentials.login}
                onChange={handleChange}
                className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ingrese su usuario"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Contraseña
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                value={credentials.password}
                onChange={handleChange}
                className="block w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ingrese su contraseña"
              />
            </div>
          </div>

          <div>
            <Button
              buttonType="submit"
              type="primary"
              className="w-full flex justify-center"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="mr-2" />
                  Iniciando sesión...
                </>
              ) : (
                'Iniciar sesión'
              )}
            </Button>
          </div>
        </form>
      </div>

      {showShopSelection && (
        <ShopSelectionModal
          isOpen={showShopSelection}
          onShopSelected={onShopSelectedComplete}
          onCancel={handleShopSelectionCancel}
        />
      )}
    </div>
  );
};

export default Login;